/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {InputComponent} from '../input/input.component';

@Component({
    selector: 'app-input-textarea',
    templateUrl: './input-textarea.component.html',
    styleUrls: [
        '../input/input.component.css',
        './input-textarea.component.css'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputTextareaComponent extends InputComponent implements OnInit, OnDestroy {

    constructor(protected formBuilder: UntypedFormBuilder) {
        super(formBuilder);
    }
}
